import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import intl from 'react-intl-universal'

import { ClockCircleFill, DownFill } from 'antd-mobile-icons'
import CurrencySymbol from '../../../components/CurrencySymbol'
import ActivityDetail from '../../activity/Profile'
import SpaProduct from '../../spa/Product'
import defaultImg from '../../../assets/images/def_img_food.png'
import RelateTagList from '../../../components/RelateTagList'
import './index.less'
import KeepAlivePopup from '../../../components/KeepAlivePopup'
import ProductDetail from '../../../components/ProductMenu/Detail'
import AutoImage from '../../../components/AutoImage'
import { getBookingTimeStr } from '../../../utils/bookRule'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'

import ProductDesc from '../../../components/ProductDesc'
import PriceText from '../../../components/ProductMenu/PriceText'

const FROM_MAP = {
    3: 'spa',
    7: 'product',
    10: 'activity',
    11: 'tour',
    14: 'souvenir',
    15: 'voucher'
}
const ProductCard = ({ title = '', viewAll = false, list = [], storeInfo = {}, from = '', areaId = '' }) => {
    const [pageState, setPageState] = useState({
        visible: false,
        item: null
    })
    const navigate = useNavigate()
    console.log(storeInfo, '===///storeinfo==////')
    const { shortName = '', name = '', productImages } = storeInfo
    const nTitle = shortName || name || title

    const nImage = productImages || defaultImg


    const handleProductClick = (item) => {
        const from = FROM_MAP[storeInfo.type]
        if (!from) return
        if (storeInfo.type === 14) { // 纪念品

            navigate(`/souvenir?areaid=${areaId}&storeid=${storeInfo.storeId}&title=${nTitle}&productid=${item.productId}`)

            // navigate(`/relate-product?productId=${item.productId}&areaId=${areaId}`)
        } else if (storeInfo.type === 15) { // 优惠券
            navigate(`/relate-product?productId=${item.productId}&voucherId=${storeInfo.storeId}`)
        } else {
            navigate(`/preview?storeId=${storeInfo.storeId}&areaId=${areaId}`, { state: { storeInfo, currentProduct: item, from } })
        }

        addBehaviorsRecord({
            behaviorType: 160200,
            behavior: 160206,
            storeId: storeInfo.storeId,
            value1: item.productId,
            value2: 'recommend'
        })
    }
    return (
        <div className='pd-card-wrapper'>
            <div className='pd-card-header'>
                <div className='pd-card-title ellips jm-flex-item'>
                    <span>{nTitle}</span>
                </div>
                {viewAll && (
                    <div className='check-all'
                        onClick={() => {
                            if (from === 'souvenir') {
                                navigate(`/souvenir?areaid=${areaId}&storeid=${storeInfo.storeId}&title=${nTitle}`, { state: { storeInfo, from } })
                            } else if (from === 'activity') {
                                navigate(`/activity?areaid=${areaId}&storeid=${storeInfo.storeId}`, { state: { storeInfo, from } })
                            } else if (from === 'voucher') {
                                navigate(`/voucher?areaid=${areaId}&storeid=${storeInfo.storeId}&title=${nTitle}`)
                            } else {
                                navigate(`/activity/more?areaId=${areaId}&storeId=${storeInfo.storeId}&title=${nTitle}`, { state: { merchantInfo: { ...storeInfo, areaId } } })
                            }
                            // navigate(`/activity/more?areaId=${areaId}&storeId=${storeInfo.storeId}`, { state: { merchantInfo:{...storeInfo ,areaId} } })

                            addBehaviorsRecord({
                                behaviorType: 160200,
                                behavior: 160205,
                                storeId: storeInfo.storeId,
                            })
                        }}>
                        {intl.get('h_check_all').d('Check all')} <DownFill style={{ transform: 'rotate(-90deg)' }} />
                    </div>
                )}

            </div>

            <ul className='scrollx-box' style={{ gap: 10 }}>
                {list.map((item, index) => {
                    const { nDay, timeStr } = getBookingTimeStr(item) || {}
                    return <li className='scroll-item' key={index}
                        onClick={() => {
                            handleProductClick(item)
                        }}>
                        <div className='scroll-item-img'>
                            <AutoImage src={item.images || nImage} alt="product-image" onError={(e) => { e.target.src = nImage }} />
                        </div>
                        <div className='scroll-info'>
                            <div className='scroll-title jm-flex-item ellips_line2' style={{ height: 42, marginBottom: 1 }}>{item.name}</div>
                            {
                                // item.description && <div className='scroll-desc m-t-sm'><ProductDesc list={item.description} ellipsis={true} /></div>
                            }
                            {
                                <div className='scroll-x' style={{ height: 32, marginBottom: 1 }}>
                                    {item.tagRelates && <RelateTagList list={item.tagRelates} wrap={false} />}
                                </div>
                            }

                            {timeStr && <div className='scroll-time jm-flex'>
                                <ClockCircleFill fontSize={15} color='var(--adm-color-primary)' />
                                <div className='jm-flex-item'>{nDay} {timeStr}</div>
                            </div>
                            }
                            <div className='scroll-price jm-price fs-16' style={{ marginBottom: 0 }}>
                                <b>
                                    <PriceText product={item} />
                                </b>
                            </div>
                        </div>
                    </li>
                })}
            </ul>
            <KeepAlivePopup
                visible={pageState.visible}
                onClose={() => setPageState({ visible: false, item: null })}
                destroyOnClose
            >
                {
                    pageState.visible
                        ?
                        <>
                            {
                                storeInfo.type === 7 ?
                                    <ProductDetail
                                        currentItem={pageState.item}
                                        callback={() => setPageState({ visible: false, item: null })}
                                        readonly={true} />
                                    : null
                            }
                            {
                                storeInfo.type === 10 ?
                                    <ActivityDetail
                                        detail={pageState.item}
                                        callback={() => setPageState({ visible: false, item: null })} />
                                    : null
                            }
                            {
                                storeInfo.type === 3 ?
                                    <SpaProduct
                                        merchantInfo={storeInfo}
                                        list={[]}
                                        callback={() => { setPageState({ visible: false, item: null }) }} />
                                    : null
                            }
                        </>

                        :
                        null
                }
            </KeepAlivePopup>
        </div>
    )
}

export default ProductCard